/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RealitesInputs */

const cs_enum_realites = /** @type {(inputs: Enum_RealitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realites`)
};

const en_enum_realites = /** @type {(inputs: Enum_RealitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realites`)
};

/**
* | output |
* | --- |
* | "Realites" |
*
* @param {Enum_RealitesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realites = /** @type {((inputs?: Enum_RealitesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RealitesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realites(inputs)
	return cs_enum_realites(inputs)
});